import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TurnoverConfigurationStepAssigneesEffects } from '@main-application/management/pages/turnover-configuration/components/turnover-configuration-step-assignees/store/effects/turnover-configuration-step-assignees.effects';
import * as fromResponsibleParties from '@main-application/management/pages/turnover-configuration/components/turnover-configuration-step-assignees/store/reducers/turnover-configuration-step-assignees.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([TurnoverConfigurationStepAssigneesEffects]),
    StoreModule.forFeature(fromResponsibleParties.reponsiblePartiesFeatureKey, fromResponsibleParties.reducer),
  ],
})
export class TurnoverConfigurationStepStoreModule {}
